document.querySelectorAll('.coast-usage-moment').forEach((section) => {
  const image = section.querySelector('.coast-usage-moment__image');
  const panelInner = section.querySelector('.coast-usage-moment__panel-inner');
  if (!image || !panelInner) return;

  let resizeTimer;

  function checkOverflow() {
    if (window.innerWidth < 750) {
      section.classList.remove('is-stacked');
      return;
    }
    section.classList.remove('is-stacked');
    const imageHeight = image.getBoundingClientRect().height;
    const panelContentHeight = panelInner.scrollHeight;
    if (panelContentHeight > imageHeight) {
      section.classList.add('is-stacked');
    }
  }

  function scheduleCheck() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(checkOverflow, 150);
  }

  if (window.ResizeObserver) {
    new ResizeObserver(scheduleCheck).observe(section);
  } else {
    window.addEventListener('resize', scheduleCheck);
  }

  if (image.querySelector('img') && !image.querySelector('img').complete) {
    image.querySelector('img').addEventListener('load', checkOverflow, { once: true });
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(checkOverflow);
  }

  checkOverflow();
});
